module.exports = __webpack_public_path__ + "static/media/FT-ROSTRO-3D.975aee39.png";